// ##### 25-02-05 Komarov
import { Select } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const MealComponent = ({ props }) => {
  const { selectMealType, mealType, mealTypeInitialState } = props;
  // ##### Komarov 2025-08-05
  const SupplierForm_PleaseSelect = useSelector(state => state.pagesRedux[state.language]?.SupplierForm_PleaseSelect || '');

  const mealTypes = [
    useSelector(state => state.pagesRedux[state.language]?.['All Inclusive'] || ''),
    useSelector(state => state.pagesRedux[state.language]?.['Full board'] || ''),
    useSelector(state => state.pagesRedux[state.language]?.Breakfast || ''),
    useSelector(state => state.pagesRedux[state.language]?.Lunch || ''),
    useSelector(state => state.pagesRedux[state.language]?.Dinner || ''),
    useSelector(state => state.pagesRedux[state.language]?.['Half board'] || ''),
    useSelector(state => state.pagesRedux[state.language]?.['Breakfast and Lanch'] || ''),
    useSelector(state => state.pagesRedux[state.language]?.['Lunch and Dinner'] || ''),
    useSelector(state => state.pagesRedux[state.language]?.['Without Food'] || ''),
  ];

  const chooseTypeOfMeal = useSelector(state => state.pagesRedux[state.language]?.chooseTypeOfMeal || '');

  return (
    <div className="groupTravelblocks_2" key={uniqueId()}>
      <span>{chooseTypeOfMeal}</span>
      <Select
        onChange={selectMealType}
        bordered={true}
        style={{ minWidth: '5vw' }}
        key={uniqueId()}
        // ##### 24-03-21 Komarov
        value={
          (mealType === mealTypeInitialState && SupplierForm_PleaseSelect) ||
          mealType
        }
      >
        <>
          {
            // ##### 24-03-21 Komarov
            mealTypes?.map(item => (
              <Option value={item} key={item}>
                {item}
              </Option>
            ))
          }
        </>
      </Select>
    </div>
  );
};

// ##### 25-05-21 Komarov
export default MealComponent;
